import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {filter} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class MessageService {
  
  private subject = new Subject<any>();
  constructor(
    private http: HttpClient
  ) {}

  public emit(channel: string, data: any) {
    return this.subject.next({
      channel,
      data
    });
  }

  public getChannelObservable(channel: string): Observable<any> {
    return this.subject.asObservable().pipe(filter((res: any) => (res.channel === channel)));
  }
}
